export default "__VITE_ASSET__21a3132e__"